import { invitationConstants } from "../constants/invitation.constants";

export function invitation(state = {}, action) {
  switch (action.type) {
    case invitationConstants.OPEN_MODAL:
      return {
        ...state,
        loading: false,
        request: null,
        success: false,
        visible: true,
      };
    case invitationConstants.SEND_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        success: false,
        errorMessage: null,
      };
    case invitationConstants.SEND_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case invitationConstants.SEND_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        errorMessage: action.payload,
      };
    case invitationConstants.CLOSE_MODAL:
      return {
        ...state,
        visible: false,
      };
    case invitationConstants.GET_BY_SENDER_ID_REQUEST:
      return {
        ...state,
        loadingGrid: true,
        request: action.payload,
      };
    case invitationConstants.GET_BY_SENDER_ID_SUCCESS:
      return {
        ...state,
        loadingGrid: false,
        paginatedResult: action.payload,
      };
    case invitationConstants.GET_BY_SENDER_ID_FAILURE:
      return {
        ...state,
        loadingGrid: false,
      };
    case invitationConstants.RESEND_REQUEST:
      return {
        ...state,
        resending: true,
        resendingId: action.payload,
        resendSuccess: false,
        resendError: null,
      };
    case invitationConstants.RESEND_SUCCESS:
      return {
        ...state,
        resending: false,
        resendingId: null,
        resendSuccess: true,
        resendSuccessId: action.payload,
      };
    case invitationConstants.RESEND_FAILURE:
      return {
        ...state,
        resending: false,
        resendingId: null,
        resendSuccess: false,
        resendError: action.payload,
      };
    default:
      return state;
  }
}
